import { defineStore } from 'pinia'
import { getNyalaCustomerVaultData, getNyalaCustomerVaultDataLegal } from '../api/nyala-customer'
import { usePersonalAccountDataState } from './useAccountDataPersonal'
import { isNaturalProfile } from '../investment-process/useUserProfileType'
import { useLegalAccountDataState } from './useAccountDataLegal'

export const useNyalaCustomerVaultData = defineStore('nyala-customer-vault', {
    state: () => {
        return {
            loading: false,
            loaded: false,
            id: null,
            is_created: null,
            explorer_url: null,
        }
    },
    actions: {
        async fetchVaultData() {
            this.loading = true
            try {
                const response = isNaturalProfile()
                    ? await getNyalaCustomerVaultData(usePersonalAccountDataState().naturalProfile.natural_profile_uid)
                    : await getNyalaCustomerVaultDataLegal(useLegalAccountDataState().legalProfile.legal_profile_uid)
                this.loading = false
                this.loaded = true
                this.$patch(response.data)
            } finally {
                this.loading = false
            }
        },
        async generateRandomPin() {
            const length = 6

            const buffer = new Uint8Array(length)
            const crypto = window.crypto || (window as any).msCrypto // For compatibility with IE11.
            const array = await crypto.getRandomValues(buffer)
            let password = ''

            const characters = '0123456789'

            for (let i = 0; i < length; i++) {
                password += characters.charAt(array[i] % characters.length)
            }

            return password
        },
        isValidPin(pin: string) {
            return pin !== null && pin.length === 6 && pin.match(/^[0-9]+$/) !== null
        },
    },
})
